import React from 'react';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppDispatch } from 'hooks';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { NetworkConfig } from 'config';
import { appActions } from 'store/app';
import { toast } from 'react-toastify';

const StyledBox = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'disabled',
})<{ isSelected?: boolean; disabled?: boolean }>`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 10px;
	margin-right: 20px;
	width: 100%;
	margin-bottom: 8px;
	border-radius: 4px;
	border: 1px solid #d6d6d6;
	cursor: pointer;
	background: ${({ isSelected, disabled }) =>
		!disabled
			? isSelected
				? 'rgb(228, 228, 228)'
				: 'rgb(249, 249, 249)'
			: 'rgb(249, 249, 249)'};

	&:hover {
		background-color: ${({ disabled }) =>
			!disabled ? 'rgb(238, 238, 238)' : 'none'};
	}
`;

const NetworkTitle: React.ComponentType<NetworkConfig> = ({
	label,
	image,
	name,
	disabled,
	comingSoon,
}) => {
	const dispatch = useAppDispatch();
	const appState = useSelector((state: RootState) => state.app);

	const onItemSelect = () => {
		dispatch(appActions.setSelectedChain(name));
	};

	return (
		<StyledBox
			onClick={() => {
				if (comingSoon) {
					toast('Coming soon. Please connect on discord.', {
						type: 'info',
					});
					return;
				}
				if (disabled) {
					toast('Temporary unavailable', {
						type: 'info',
					});
					return;
				}

				onItemSelect();
			}}
			isSelected={name === appState.selectedNetwork}
			disabled={disabled}
		>
			<img src={image} height={24} />
			<Box
				sx={{
					width: 10,
				}}
			/>
			<Typography
				variant={'caption'}
				textAlign="center"
				color={'#111'}
				fontWeight={500}
			>
				{label}
			</Typography>
		</StyledBox>
	);
};

export { NetworkTitle };
